




import {
  computed,
  defineComponent,
  onMounted,
  useStore,
} from '@nuxtjs/composition-api'
import { getCityCookie } from '@/utils/cityCookie'
export default defineComponent({
  setup(_props) {
    const store = useStore()
    const city = computed(() => {
      return store.getters['popupCityList/getCity']?.length > 16
        ? store.getters['popupCityList/getCity'].substring(0, 16) + '...'
        : store.getters['popupCityList/getCity']
    })
    onMounted(() => {
      const cookieCity = getCityCookie()
      if (cookieCity) store.commit('popupCityList/SET_CITY_NAME', cookieCity)
    })
    return {
      city,
    }
  },
})
